import { render } from "./Find.vue?vue&type=template&id=08024887&scoped=true"
import script from "./Find.vue?vue&type=script&lang=js"
export * from "./Find.vue?vue&type=script&lang=js"

import "./Find.vue?vue&type=style&index=0&id=08024887&lang=less&scoped=true"

import exportComponent from "D:\\xm\\zhongzai\\qianduan\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08024887"]])

export default __exports__